<template>
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="56"
      height="56"
      rx="8"
      fill="var(--gray50)"
    />
    <path
      d="M39 26.3929V27.0358C39 27.5683 38.5896 28.0001 38.0833 28.0001H37.7778L36.7804 35.3442C36.6514 36.2943 35.8779 37 34.9655 37H21.0345C20.1221 37 19.3486 36.2943 19.2196 35.3442L18.2222 28.0001H17.9167C17.4104 28.0001 17 27.5683 17 27.0358V26.3929C17 25.8604 17.4104 25.4286 17.9167 25.4286H20.4887L24.5671 19.5296C24.9642 18.9554 25.7285 18.8284 26.2745 19.246C26.8204 19.6637 26.9411 20.4678 26.544 21.0421L23.5113 25.4286H32.4887L29.456 21.042C29.0589 20.4678 29.1797 19.6637 29.7256 19.246C30.2714 18.8284 31.0359 18.9553 31.4329 19.5296L35.5113 25.4286H38.0833C38.5896 25.4286 39 25.8604 39 26.3929ZM28.9167 33.4643V28.9643C28.9167 28.4318 28.5063 28.0001 28 28.0001C27.4937 28.0001 27.0833 28.4318 27.0833 28.9643V33.4643C27.0833 33.9969 27.4937 34.4286 28 34.4286C28.5063 34.4286 28.9167 33.9969 28.9167 33.4643ZM33.1944 33.4643V28.9643C33.1944 28.4318 32.784 28.0001 32.2778 28.0001C31.7715 28.0001 31.3611 28.4318 31.3611 28.9643V33.4643C31.3611 33.9969 31.7715 34.4286 32.2778 34.4286C32.784 34.4286 33.1944 33.9969 33.1944 33.4643ZM24.6389 33.4643V28.9643C24.6389 28.4318 24.2285 28.0001 23.7222 28.0001C23.216 28.0001 22.8056 28.4318 22.8056 28.9643V33.4643C22.8056 33.9969 23.216 34.4286 23.7222 34.4286C24.2285 34.4286 24.6389 33.9969 24.6389 33.4643Z"
      fill="var(--brandPrimary)"
    />
  </svg>
</template>

